import React, { useContext, useState } from 'react'
import Image from 'react-bootstrap/Image'
import avatar from 'assets/images/campaign/avater.svg'
import menu from 'assets/images/widgets/Menu.png'
import logo from 'assets/images/widgets/Tabbar.svg'
import styled from 'styled-components'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import SideMenuSection from 'Influencers/influencerComponents/SideMenu/SideMenuSection'
import { JazeelContext } from 'Influencers/utils/JazeelContext'
import { BrandContext } from '../../utils/BrandContext'
import AvatarModal from 'components/AvatarModal'
import { RTL } from 'locales/currentLang'
import { useHistory } from 'react-router'
import langUrl from 'CampaignSystem/utils/langUrl'

const HeaderWrapper = styled(Row)`
  height: 4.688em;
  //background: linear-gradient(45deg, #11bed3 0%, #9cdf61 100%);
  background: white;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.14);
  justify-content: space-between;
  padding-top: 0.938em;
  padding-bottom: 0.875em;
  margin: 0;
  .modal-open & {
    filter: blur(11px);
  }
`

const Logo = styled(Col)`
  //height: 2.875em;
  //width: 7em;
  background: url(${logo}) no-repeat center;
  background-size: contain;
  background-position: ${props => props.size};
`
const Menu = styled(Col)`
  height: 2em;
  width: 2.75em;
  margin-top: 0.3em;
  //margin-right: 5.031em;
  background: url(${menu}) no-repeat;
  background-size: 1.2em;
  background-position-y: 40%;
  background-position-x: ${props =>
    props.theme.dir === 'left' ? '85%' : '15%'};
`
const Avatar = styled(Image)`
  box-sizing: border-box;
  height: 2.063em;
  width: 2.063em;
  border: 1px solid #ffffff;
  border-radius: 50%;
  margin-top: 0.375em;
  float: ${props => props.theme.dir};
  margin-${props => props.theme.dir}: 0.281em;
`
export default function CampaignHeader() {
  const { setMobileMenuOpen, userData } = useContext(JazeelContext)
  const { brandData } = useContext(BrandContext)
  const history = useHistory()
  const [successShow, setSuccessShow] = useState(false)
  const handleSuccessShow = () => setSuccessShow(true)
  const handleSuccessHide = () => setSuccessShow(false)
  return (
    <HeaderWrapper>
      <Menu xs={4} onClick={() => setMobileMenuOpen(true)}>
        {/*<Menu*/}
        {/*  // src={menu}*/}
        {/*  // fluid*/}
        {/*alt="menu"*/}
        {/*/>*/}
      </Menu>
      {(brandData && localStorage.getItem('brandData:')) ||
      (userData && localStorage.getItem('userData:')) ? (
        <Logo
          xs={4}
          size="50%"
          onClick={() =>
            history.push(
              `/${langUrl}/${brandData ? 'brand' : 'influencer'}/dashboard`,
            )
          }
        />
      ) : (
        <Logo
          xs={8}
          size={RTL() ? '10%' : '85%'}
          onClick={() => history.push(`/${langUrl}`)}
        />
      )}
      {/*<Logo xs={8}>*/}
      {/*  /!*<Logo src={logo} fluid />*!/*/}
      {/*</Logo>*/}
      <Col xs={4}>
        {brandData && localStorage.getItem('brandData:') && (
          <Avatar
            src={brandData?.image ? brandData?.image : avatar}
            fluid
            onClick={handleSuccessShow}
            alt="avatar"
          />
        )}
        {userData && localStorage.getItem('userData:') && (
          <Avatar
            src={userData?.image ? userData?.image : avatar}
            fluid
            onClick={handleSuccessShow}
            alt="avatar"
          />
        )}
      </Col>
      <AvatarModal
        show={successShow}
        onHide={handleSuccessHide}
        avatar={
          userData ? userData.image : brandData ? brandData.image : avatar
        }
        type={userData ? 'influencer' : 'brand'}
      />
    </HeaderWrapper>
  )
}
